import { CTA_LABEL } from '../constants';

const ctaLabelsToBeReplaced = [/Get Info/gi, /Submit Info/gi];

// Replace all CTA labels in TCPA with the CTA_LABEL
export const replaceCTALabelInTCPA = (tcpa: string): string =>
  ctaLabelsToBeReplaced.reduce((acc, ctaLabel) => acc.replace(ctaLabel, CTA_LABEL), tcpa);
